<footer class="auth-footer">
  <div class="auth-footer__links">
    <a routerLink="/privacy-policy">Privacy Policy</a>
    <span class="auth-footer__separator">|</span>
    <a routerLink="/terms-and-conditions">Terms of Service</a>
  </div>
  <div class="auth-footer__copyright">
    &copy; {{ currentYear }} A2J Software Ltd.
  </div>
</footer>
